// form submit
document.querySelector("#cartForm").addEventListener("submit", async function (e) {
    e.preventDefault();

    // create formdata
    const formData = new FormData(this);

    // create object from formdata
    const payload = Object.fromEntries(formData.entries());

    // add hostname
    payload.hostname = window.location.hostname;

    // start loading on button
    document.querySelector("#cartFormSubmit").classList.add("loading");

    // domains with direct checkout skip the provider review and pay at checkout
    if (this.dataset.directCheckout === "true") {
        await directCheckout(payload);
        return;
    }

    // add cart items to payloads
    payload.cart = cart;

    // send payload to server
    const response = await fetch(`${root}/guest/new-pending-order.php`, {
        method: "POST",
        body: JSON.stringify(payload)
    })
        .then((res) => res.json())

    // stop loading
    document.querySelector("#cartFormSubmit").classList.remove("loading");

    // check for error
    if (response.error) {
        // show error message
        Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: response.error,
        });
        return;
    }

    // clear cart
    await fetch(`${Shopify.routes.root}cart/clear.js`);

    // redirect to thank you page
    window.location.href = `${Shopify.routes.root}pages/thank-you`;
});

/********************* Direct Checkout *********************/

// tag each line with its artist's kit address, save the order details on the cart, then go to checkout
async function directCheckout(payload) {
    // fetch the artists
    const artists = await fetch(`${root}/director/get-artists.php`)
        .then((res) => res.json())

    // each change waits for the one before it, since every call rewrites the cart
    for (const item of cart.items) {
        // skip lines without a matching artist
        const artist = artists.find(artist => artist.vendor_name === item.vendor);
        if (!artist) {
            continue;
        }

        // add the kit address to the line's existing properties
        const response = await changeCart({
            id: item.key,
            quantity: item.quantity,
            properties: {
                ...item.properties,
                "_Send Kit To": kitAddress(artist)
            }
        });

        // shopify returns a status only when the change fails
        if (response.status) {
            document.querySelector("#cartFormSubmit").classList.remove("loading");
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: response.description || response.message,
            });
            return;
        }
    }

    // save the order details so they reach the order and the director's dashboard
    await updateCart({
        attributes: payload
    });

    // redirect to checkout
    window.location.href = `${Shopify.routes.root}checkout`;
}
